import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export const notesService = {
  async getNotesByExpeditionAndWeek(expeditionId: string, week: string) {
    const response = await api.get(
      API_ROUTES.GET_ADVENTURER_NOTES_BY_EXPEDITION_AND_WEEK(expeditionId, week)
    )
    return response.data
  },

  async getNotesByExpeditionAndAdventurer(expeditionId: string, adventurerId?: number) {
    const response = await api.get(
      API_ROUTES.GET_ADVENTURER_NOTES_BY_EXPEDITION_AND_ADVENTURER(expeditionId, adventurerId)
    )
    return response.data
  },

  async createNote(payload: { adventurer?: number; expedition: string; week: number; note: string; is_expedition_wide?: boolean }) {
    return await api.post(API_ROUTES.CREATE_ADVENTURER_NOTE, payload)
  },

  async updateNote(noteId: number, payload: { note: string }) {
    return await api.patch(API_ROUTES.EDIT_ADVENTURER_NOTE(String(noteId)), payload)
  },

  async deleteNote(noteId: number) {
    return await api.delete(API_ROUTES.EDIT_ADVENTURER_NOTE(String(noteId)))
  }
} 